import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  dataByType: {}, 
  loading: false,
  error: null,
  paginationByType: {} 
};

/* ================== THUNKS ================== */

export const fetchCategory = createAsyncThunk(
  'category/fetch',
  async ({ page = 1, limit = 10, search = '', type }, { rejectWithValue }) => {
    try {
      console.log(search,'search');
      const response = await axiosInstance.get('/api/admin/categories', {
        params: { page, limit, search, type }
      });
      return { type, ...response.data };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createCategory = createAsyncThunk(
  'category/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/categories', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateCategory = createAsyncThunk(
  'category/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/categories/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  'category/delete',
  async ({ id, type }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/categories/${id}`);
      return { id, type };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

/* ================== SLICE ================== */

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* FETCH */
      .addCase(fetchCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategory.fulfilled, (state, action) => {
        const { type, data, pagination } = action.payload;
        state.loading = false;
        state.dataByType[type] = data;
        state.paginationByType[type] = pagination;
      })
      .addCase(fetchCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CREATE */
      .addCase(createCategory.fulfilled, (state, action) => {
        const type = action.payload.type;
        state.dataByType[type] = [
          ...(state.dataByType[type] || []),
          action.payload
        ];
      })

      /* UPDATE */
      .addCase(updateCategory.fulfilled, (state, action) => {
        const type = action.payload.type;
        state.dataByType[type] = state.dataByType[type].map(cat =>
          cat._id === action.payload._id ? action.payload : cat
        );
      })

      /* DELETE */
      .addCase(deleteCategory.fulfilled, (state, action) => {
        const { id, type } = action.payload;
        state.dataByType[type] = state.dataByType[type].filter(
          cat => cat._id !== id
        );
      });
  }
});

export default categorySlice.reducer;